import { http } from "@/core/api/";

const apiBaseUrl = "/api/student/visualimpairments";
export const addStudent = model => {
  return http.post(`${apiBaseUrl}/addstudent`, model);
};
